export default function useLinking() {
  return {
    openLink: (url: string | undefined) => {
      window.open(url, '', 'noreferrer noopener');
    },
    openLinkNewWindow: (url: string | undefined, features?: string) => {
      window.open(url, '_blank', features);
    },
  };
}
